class Globals{
  constructor(){
    this._testsMode = false;
    this._mediaQ;
  }

  get testsMode() {
    return this._testsMode;
  }

  set testsMode(value) {
    this._testsMode = value;   // validation could be checked here such as only allowing non numerical values
  }

  get mediaQ() {
    return this._mediaQ;
  }

  set mediaQ(value) {
    this._mediaQ = value;   // validation could be checked here such as only allowing non numerical values
  }

}

const globals = new Globals();

export default globals;